// import { Link } from 'react-router-dom';
import './AboutContentStyles.css';
import React from 'react';
import ww3 from '../assets/ww3.png';
import ww4 from '../assets/ww4.png';
import { motion } from 'framer-motion';

const AboutContent = () => {
  return (
    <div className='about'>
        <div className='left'>
            <h1>Recent Web Projects Preview</h1>
        </div>
        <div className='right'>
            <div className='img-container'>
                <div className='img-stack top'>
                    <motion.img  src={ww3} alt='abt1' className='img'
                    animate={{x:0}}
                    initial={{x:-100}}
                    transition={{
                        duration:1.5,
                        damping:2,
                        stiffness:100,
                        type:'tween',
                    }}                   
                    whileHover={{scale:1.1}}
                    drag
                    dragConstraints={{
                        left:-20,
                        right:20,
                        top:-10,
                        bottom:10,
                    }}
                    />
                </div>
                <div className='img-stack bottom'>
                    <motion.img  src={ww4} alt='abt2' 
                    className='img'
                    animate={{x:0}}
                    initial={{x:100}}
                    transition={{
                        duration:1.5,
                        damping:2,
                        stiffness:100,
                        type:'tween',
                    }}   
                    whileHover={{scale:1.1}}
                    drag
                    dragConstraints={{
                        left:20,
                        right:-20,
                        top:10,
                        bottom:-10,
                    }}                     
                    />
                </div>
            </div>
        </div>  
    </div>
  )
}

export default AboutContent;